// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {TooltipEl} from 'common/components/tooltip';
import {ButtonEl} from 'common/components/button';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {instrumentWithTimer} from 'common/util/workflow-timing';

import type {ControlBar} from './index';

export function template(this: ControlBar) {
  const {contextPanelTransform} = this.params;
  const {print} = this.getContext(`i18n`);

  return (
    <div sel='.mp-control-bar' attrs={{elref: `menuItems`}}>
      {(() => {
        const overflowItems = this.getOverflowItems();
        const controls = this.params.controls;

        return (
          <>
            {controls?.items.map((section, index) => {
              const {isDisabled, icon, highlightIcon, label, theme, value, slot, tooltip, elref} = section;

              return (
                <div sel='.mp-control-bar-control'>
                  {tooltip && <TooltipEl attrs={tooltip} />}
                  {slot ? (
                    <slot attrs={{name: slot}} />
                  ) : (
                    <ButtonEl
                      key={`${index}-value`}
                      attrs={{
                        disabled: isDisabled,
                        icon,
                        'highlight-icon': highlightIcon,
                        value,
                        theme: theme || this.params.theme,
                        elref,
                      }}
                      on={{
                        click: instrumentWithTimer(this.handleClick),
                      }}
                    >
                      {label ? print(label) : null}
                    </ButtonEl>
                  )}
                </div>
              );
            })}
            {overflowItems.length ? (
              <div sel='.mp-control-bar-truncated-menu-container'>
                <SelectEl
                  attrs={{
                    theme: SelectTheme.Tertiary,
                    size: this.params.size,
                    'show-preview-tooltip': !this.params.overflowTooltip,
                    tooltip: this.params.overflowTooltip,
                    icon: {
                      leftIcon: this.params.overflowIcon,
                    },
                    'icon-only': true,
                    'menu-width': this.params.overflowMenuWidth,
                    'menu-height': this.params.overflowMenuHeight,
                    'menu-alignment': this.params.overflowMenuAlignment,
                    elref: `overflowMenu`,
                    disabled: this.params.disabled,
                    'disable-tooltip': this.params.disableTooltip,
                  }}
                  on={{
                    change: this.handleMenuClick,
                    menuChange: this.handleMenuChange,
                  }}
                  props={{contextPanelTransform, sections: overflowItems}}
                />
              </div>
            ) : null}
          </>
        );
      })()}
    </div>
  );
}
